import { createContext, Dispatch, SetStateAction, useEffect, useState } from "react";
import SearchArea from "./components/SearchArea";
import ClaimList from "./components/ClaimList";
import { useMutation } from "react-query";
import {
  // Box,
  Paper,
  Typography,
  //  Tab,
  //  Tabs
} from "@mui/material";
import { TableDataLoading } from "../../utilis/component/SkeletonLoading/PageLoadSkeleton";
import { getClaimListTableData } from "../services";
import { ClaimListingFilterType } from "../types";
import usePopup from "../../hooks/usePopup";

type FilterType = Omit<ClaimListingFilterType, "clinicId">;
export type ClaimContextType = {
  tableData: any[];
  filter: FilterType;
  setFilter: Dispatch<SetStateAction<FilterType>>;
  refetch:boolean;
  setRefetch:Dispatch<SetStateAction<boolean>>,
  setTableData:Dispatch<SetStateAction<any[]>>
};
export const ClaimContext = createContext<ClaimContextType | null>({
  tableData: [],
  filter: {
    verificationStatus: 1,
    date: "",
    toDate: "",
    pageSize: 25,
    pageNo: 0,
    flag: 1,
    insuranceType: "",
    receiver: "",
    payer: "",
    postOfficeId: 1,
    all:true
  },
  setFilter: () => {},
  refetch:true,
  setRefetch:()=>{},
  setTableData:()=>{}
});

function ClaimListing() {
  const { showSnackbar } = usePopup();
  const [filter, setFilter] = useState<FilterType>({
    verificationStatus: 1,
    date: "",
    toDate: "",
    pageSize: 25,
    pageNo: 0,
    flag: 1,
    insuranceType: "",
    receiver: "",
    payer: "",
    postOfficeId: 1,
    all:true
  });
  const [tableData,setTableData] = useState<any[]>([])
  const [refetch,setRefetch] = useState(true)
  const { mutate, isLoading, } = useMutation(getClaimListTableData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        setTableData(result.response || [])
        setRefetch(false)
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
        });
      }
    },
    onError: () => {
      showSnackbar({
        message: "Something went wrong",
        open: true,
        variant: "warning",
      });
    },
  });

  // const tableData = useMemo(() => {
  //   if (data?.response?.length) {
  //     return [...data.response];
  //   } else {
  //     return [];
  //   }
  // }, [data?.response]);

  // const handleChange = (_: React.SyntheticEvent, newValue: number) => {
  //   setValue(newValue);
  // };

  useEffect(() => {
      if (filter.date && filter.toDate) {
        if(refetch){
          mutate(filter);
        }
      }
  }, [filter,refetch]);

  return (
    <ClaimContext.Provider value={{ tableData, setTableData,filter, setFilter,refetch,setRefetch }}>
      <div className="flex flex-col gap-4 p-3">
        <div>
          <Typography
            margin={0}
            color="primary"
            fontSize={14}
            fontWeight={"bold"}
          >
            Insurance - Claim listing
          </Typography>
        </div>
        <SearchArea />
        <Paper sx={{ width: "100%" }}>
          {isLoading ? <TableDataLoading cols={12} rows={10} /> : <ClaimList />}
        </Paper>
      </div>
    </ClaimContext.Provider>
  );
}

export default ClaimListing;
